<template>
    <BaseLink :href="redirectUrl" :aria-label="t('components.organizationLogo.home')">
        <img v-if="organizationDetails && organizationDetails.logo_url" :class="imageClass" :src="organizationDetails.logo_url" alt="" aria-hidden="true" />
        <img v-else :class="imageClass" :src="Logo" alt="" aria-hidden="true" />
    </BaseLink>
</template>

<script setup>
import Logo from "~img/logo.png";
import BaseLink from "~vue/router/BaseLink.vue";
import { isInIFrame } from "~vue/utils";
import { computed, inject } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const organizationDetails = inject("organization_details");

const { url } = defineProps({
    url: { type: String, default: "/" },
    imageClass: { type: String, default: "" },
});

const redirectUrl = computed(() => {
    return isInIFrame() ? `${url}?client=teams` : `${url}`;
});
</script>
